import Util from '../util';

/**
 * (?=.*\d)          should contain at least one digit
 * (?=.*[!@#$%^&*_]) should contain at least one special character
 * (?=.*[a-z])       should contain at least one lower case
 * (?=.*[A-Z])       should contain at least one upper case
 * [a-zA-Z0-9]{8,}   should contain at least 8 from the mentioned characters
 */
const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z_@./#&+-]{8,}$/;
const PASSWORD_MESSAGE = 'Password should consist of at least 8 characters (1 digit, 1 lower case, 1 upper case)';
const PIN_REGEX = /^[0-9]{6}$/;
const PIN_MESSAGE = 'Pin should consist of 6 DIGITS';

function NumberValidator(rule, value) {
	let min = rule.min;
	let max = rule.max;
	const message = rule.message;
	if (min !== undefined) min = Number(min);
	if (max !== undefined) max = Number(max);
	try {
		const object = Number(value);
		if (min !== undefined && object < min) throw new Error(message);
		if (max !== undefined && object > max) throw new Error(message);
		if (isNaN(object)) throw new Error(message);
		return Promise.resolve();
	} catch (err) {
		return Promise.reject(err);
	}
}

const InputRules = {
	required: (msg) => [{ required: true, message: msg || 'Required' }],
	email: [
		{ required: true, message: 'Please enter your email.' },
		{ type: 'email', message: 'Incorrect email' },
	],
	password: [
		{ required: true, message: 'Please enter your password!' },
		({ getFieldValue }) => ({
			validator(rule, value) {
				if (!value || value.match(PASSWORD_REGEX)) {
					return Promise.resolve();
				}
				return Promise.reject(PASSWORD_MESSAGE);
			},
		}),
	],
	pin: [
		{ required: true, message: 'Please enter your pin!' },
		({ getFieldValue }) => ({
			validator(rule, value) {
				if (!value || value.match(PIN_REGEX)) {
					return Promise.resolve();
				}
				return Promise.reject(PIN_MESSAGE);
			},
		}),
	],
	name: [
		{ required: true, message: 'Please enter your first name!' },
		({ getFieldValue }) => ({
			validator(rule, value) {
				if (value.length >= 3) {
					return Promise.resolve();
				}
				return Promise.reject('Name should be at least 3 characters long');
			},
		}),
	],
	contactNumber: (required) =>
		[
			required && { required, message: 'Please enter your contact number' },
			({ getFieldValue }) => ({
				validator(rule, value) {
					if (!Util.isValidPhoneNumber(value)) {
						return Promise.reject();
					}

					return Promise.resolve();
				},
			}),
		].filter(Boolean),
	number: ({ required, message, min, max }) =>
		[
			required && InputRules.required(message),
			{
				min,
				max,
				message: max ? `Enter valid value (${min}-${max})` : `Value should be more than ${min}`,
				validator: NumberValidator,
			},
		].filter(Boolean),
};

export default InputRules;
